module.exports = __webpack_public_path__ + "img/login-background.75cda11c.jpg";